import styled from "styled-components";

export const CardWrapper = styled.div`
  width: 100%;
`;

export const Container = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${({ theme }) => theme.CONSTANTS.XH * 2}px;
  padding-bottom: ${({ theme }) => theme.CONSTANTS.XH * 2}px;
  width: 100%;

  @media (min-width: 1025px) {
    gap: ${({ theme }) => theme.CONSTANTS.XH * 4}px;
  }
`;

export const IconWrapper = styled.div`
  width: ${({ theme }) => theme.CONSTANTS.XH * 2.5}px;
  height: ${({ theme }) => theme.CONSTANTS.XH * 2.5}px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;

  img {
    width: 40px;
    height: 40px;
  }
`;

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  text-align: start;
  flex: 1;
`;

export const Title = styled.h3`
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 24}px;
  font-weight: 600;
  color: ${({ theme }) => theme.THEME.white};
  font-family: "Sora", sans-serif;

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 7}px;
  }
`;

export const Description = styled.p`
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 24}px;
  color: ${({ theme }) => theme.THEME.white};
  font-family: "Inter", sans-serif;
  margin-top: ${({ theme }) => theme.CONSTANTS.XH * 0.5}px;
  line-height: 1.6;

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 6.5}px;
  }
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent 0%,
    ${({ theme }) => theme.THEME.neonBlue} 80%,
    transparent 100%
  );
`;
